import React from 'react';

const ChatHeader: React.FC = () => {
  return (
    <div className="p-8 pb-4">
      <h1 className="text-3xl font-bold text-gray-900 mb-2">How can I help you today?</h1>
      <p className="text-gray-600">Choose a task below or describe what you need</p>
    </div>
  );
};

export default ChatHeader;